import { render, staticRenderFns } from "./DoaWorkRecord.vue?vue&type=template&id=2eba81a3&scoped=true&"
import script from "./DoaWorkRecord.vue?vue&type=script&lang=js&"
export * from "./DoaWorkRecord.vue?vue&type=script&lang=js&"
import style0 from "./DoaWorkRecord.vue?vue&type=style&index=0&id=2eba81a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba81a3",
  null
  
)

export default component.exports